const initialState = [];

export const avatarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADICIONAR_AVATAR":
      return [...state, { 
        nome: "", 
        imagem: null, 
        tamanho: 50, 
        visivelInicial: false,
        x: 0,
        y: 0,
        visivel: false,
        rotacao: 0
      }];
    case "REMOVER_AVATAR":
      return state.filter((_, index) => index !== action.payload);
    case "ATUALIZAR_AVATAR":
      return state.map((avatar, index) =>
        index === action.payload.index
          ? { ...avatar, [action.payload.campo]: action.payload.valor }
          : avatar
      );
    case "POSICIONAR_AVATAR":
      return state.map((avatar, index) =>
        index === action.payload.index
          ? { ...avatar, x: action.payload.x, y: action.payload.y }
          : avatar
      );
    case "TOGGLE_VISIBILIDADE_AVATAR":
      return state.map((avatar, index) =>
        index === action.payload.index
          ? { ...avatar, visivel: action.payload.visivel, visivelInicial: action.payload.visivel }
          : avatar
      );
    // Ações especiais para execução (ignoram travamento)
    case "POSICIONAR_AVATAR_EXECUCAO":
      return state.map((avatar, index) =>
        index === action.payload.index
          ? { ...avatar, x: action.payload.x, y: action.payload.y }
          : avatar
      );
    case "TOGGLE_VISIBILIDADE_AVATAR_EXECUCAO":
      return state.map((avatar, index) =>
        index === action.payload.index
          ? { ...avatar, visivel: action.payload.visivel }
          : avatar
      );
    case "RESTAURAR_AVATARS_EXECUCAO":
      // Restaura posição e visibilidade dos avatares preservando outras propriedades
      return state.map((avatar, index) => {
        const avatarOriginal = action.payload[index];
        if (avatarOriginal) {
          return { 
            ...avatar, 
            x: avatarOriginal.x, 
            y: avatarOriginal.y, 
            visivel: avatarOriginal.visivel,
            rotacao: avatarOriginal.rotacao || 0
          };
        }
        return avatar;
      });
    case "SET_AVATARS":
      return action.payload || [];
    default:
      return state;
  }
};
